import BCMS, { Route } from "@bcm-dev/bcms-vite";

import "res/css/layout-styles.css";
import "res/css/shared-styles.css";

import Home from "components/shared/Home";

import IntegrationContainer from "components/shared/containers/IntegrationContainer";
// component imports
import CardOnFilePage from "components/pages/CardOnFilePage";
import CardOnFileView from "components/pages/CardOnFilePage/components/CardOnFileView";
import RecurringPaymentsView from "components/pages/CardOnFilePage/components/RecurringPaymentsView";
import ControlsAlertsPage from "components/pages/ControlsAlertsPage";
import AlertsView from "components/pages/ControlsAlertsPage/components/AlertsView";
import ControlsView from "components/pages/ControlsAlertsPage/components/ControlsView";
import EditTravelPlansPage from "components/pages/EditTravelPlansPage";
import HideShowCardsPage from "components/pages/HideShowCardsPage";
import LocationAlertsPage from "components/pages/LocationAlertsPage";
import LocationControlsPage from "components/pages/LocationControlsPage";
import LoginPage from "components/pages/LoginPage";
import MainPage from "components/pages/MainPage";
import ManagePinPage from "components/pages/ManagePinPage";
import ManageTravelPlansPage from "components/pages/ManageTravelPlansPage";
import MerchantAlertsPage from "components/pages/MerchantAlertsPage";
import MerchantControlsPage from "components/pages/MerchantControlsPage";
import MerchantDetailsPage from "components/pages/MerchantDetailsPage";
import MessagesPage from "components/pages/MessagesPage";
import RecentTransactionsPage from "components/pages/RecentTransactionsPage";
import RegionPage from "components/pages/RegionPage";
import ReportLostStolenPage from "components/pages/ReportLostStolenPage";
import ReportConfirmationView from "components/pages/ReportLostStolenPage/components/ReportConfirmationView";
import ReportView from "components/pages/ReportLostStolenPage/components/ReportView";
import SentCardToAddressView from "components/pages/ReportLostStolenPage/components/SentCardToAddressView";
import SecurityTokenPage from "components/pages/SecurityTokenPage";
import EnterSecurityTokenView from "components/pages/SecurityTokenPage/components/EnterSecurityTokenView";
import ReceiveTokenView from "components/pages/SecurityTokenPage/components/ReceiveTokenView";
import SetPinPage from "components/pages/SetPinPage";
import EnterPinView from "components/pages/SetPinPage/components/EnterPinView";
import PersonPinView from "components/pages/SetPinPage/components/PersonPinView";
import SetPinConfirmationView from "components/pages/SetPinPage/components/SetPinConfirmationView";
import SettingsPage from "components/pages/SettingsPage";
import SpendAlertsPage from "components/pages/SpendAlertsPage";
import SpendControlsPage from "components/pages/SpendControlsPage";
import SpendInsightsPage from "components/pages/SpendInsightsPage";
import WhatView from "components/pages/SpendInsightsPage/components/WhatView";
import WhenView from "components/pages/SpendInsightsPage/components/WhenView";
import WhereView from "components/pages/SpendInsightsPage/components/WhereView";
import StatementsPage from "components/pages/StatementsPage";
import TransactionAlertsPage from "components/pages/TransactionAlertsPage";
import TransactionControlsPage from "components/pages/TransactionControlsPage";
import TransactionDetailsPage from "components/pages/TransactionDetailsPage";
import TravelPlanPage from "components/pages/TravelPlanPage";
import ViewAllTransactionsPage from "components/pages/ViewAllTransactionsPage";
import FeesPaymentsView from "components/pages/ViewAllTransactionsPage/components/FeesPaymentsView";
import PurchasesView from "components/pages/ViewAllTransactionsPage/components/PurchasesView";
import ViewDigitalCardPage from "components/pages/ViewDigitalCardPage";

import AddAccountPage from "components/pages/AddAccountPage";
import AddToWalletPage from "components/pages/AddToWalletPage";
import AddCardWorkflow from "components/workflows/AddCard";
import AddTravelPlanWorkflow from "components/workflows/AddTravelPlan";
import BalanceTransferWorkflow from "components/workflows/BalanceTransferWorkflow";
import CardFreeCashWorkflow from "components/workflows/CardFreeCashWorkflow";
import DisputeTransactionWorkflow from "components/workflows/DisputeTransactionWorkflow";

import BalanceTransfersPage from "components/pages/BalanceTransfersPage";
import ManagePaymentAccountsPage from "components/pages/ManagePaymentAccountsPage";
import ManagePaymentsView from "components/pages/ManagePaymentAccountsPage/components/ManagePaymentsView";
import PaymentAccountDetailsView from "components/pages/ManagePaymentAccountsPage/components/PaymentAccountDetailsView";
import AutoPayWorkFlow from "components/workflows/AutoPayWorkFlow";
import OneTimePaymentWorkFlow from "components/workflows/OneTimePaymentWorkFlow";

import PaymentsPage from "components/pages/PaymentsPage";
import DigitalIssuanceConfirmView from "components/pages/ReportLostStolenPage/components/DigitalIssuanceConfirmView";
import TransactionDownloadPage from "components/pages/TransactionDownloadPage";

import EnableAdditionalAlertsPage from "components/pages/EnableAdditionalAlertsPage";
import PersonalInformationPage from "components/pages/PersonalInformationPage";

import ActivateCardPage from "components/pages/ActivateCardPage";
import ActivateCardVerificationPage from "components/pages/ActivateCardVerificationPage";
import AddCardPage from "components/pages/AddCardPage";
import AddCardVerificationPage from "components/pages/AddCardVerificationPage";
import PrivacyPolicyPage from "components/pages/PrivacyPolicyPage";
import ReplaceMyCardPage from "components/pages/ReplaceMyCardPage";
import ReplaceCardAddressView from "components/pages/ReplaceMyCardPage/components/ReplaceCardAddressView";
import ReplaceCardConfirmView from "components/pages/ReplaceMyCardPage/components/ReplaceCardConfirmView";
import CardOnItsWayView from "components/pages/ReportLostStolenPage/components/CardOnItsWayView";
import RecognizeTransactionsView from "components/pages/ReportLostStolenPage/components/RecognizeTransactionsView";
import TermsConditionsPage from "components/pages/TermsConditionsPage";
import UserRegistrationPage from "components/pages/UserRegistrationPage";
import UserVerificationPage from "components/pages/UserVerificationPage";

import UpdateCardOnFilePage from "components/pages/UpdateCardOnFilePage";

import ReviewingDisputePage from "components/pages/DisputeTransactionPages/ReviewingDisputePage";
import VerificationPage from "components/pages/VerificationPage";
import VerificationEnterCredsView from "components/pages/VerificationPage/components/VerificationEnterCredsView";
import VerificationSecurityCodeView from "components/pages/VerificationPage/components/VerificationSecurityCodeView";
import VerificationSuccessView from "components/pages/VerificationPage/components/VerificationSuccessView";
import CardOnFileWorkflow from "components/workflows/CardOnFileWorkflow";

// Capture components.
import CaptureTransactionList from "components/captures/DisputeTransactions/001_TransactionList";
import CaptureTransactionDetails from "components/captures/DisputeTransactions/002_TransactionDetails";
import CaptureDisputeTransaction from "components/captures/DisputeTransactions/003_DisputeTransaction";
import CaptureDisputeReason from "components/captures/DisputeTransactions/004_DisputeReason";
import CaptureDisputeGoodsServices from "components/captures/DisputeTransactions/004a_DisputeGoodsServices";
import CaptureDisputeGoodsSelected from "components/captures/DisputeTransactions/005_DisputeGoodsSelected";
import CaptureDisputeProductEntered from "components/captures/DisputeTransactions/006_ProductEntered";
import CaptureDisputeEnterDisputeExplanation from "components/captures/DisputeTransactions/007_EnterDisputeExplanation";
import CaptureDisputeExplanationEntered from "components/captures/DisputeTransactions/008_ExplanationEntered";
import CaptureDisputeDeliveryEntered from "components/captures/DisputeTransactions/009_DeliveryEntered";
import CaptureDisputeReturnEntered from "components/captures/DisputeTransactions/010_ReturnEntered";
import CaptureDisputeReturnMethodDD from "components/captures/DisputeTransactions/011_ReturnMethodDD";
import CaptureDisputeReturnMethodSelected from "components/captures/DisputeTransactions/012_ReturnMethodSelected";
import CaptureDisputeReturnDateEntered from "components/captures/DisputeTransactions/013_ReturnDateEntered";
import CaptureDisputeDisputeAmount from "components/captures/DisputeTransactions/014_DisputeAmount";
import CaptureDisputeDisputeAmountDD from "components/captures/DisputeTransactions/015_DisputeAmountDD";
import CaptureDisputeAmountSelected from "components/captures/DisputeTransactions/016_DisputeAmountSelected";
import CaptureDisputeContactMerchant from "components/captures/DisputeTransactions/017_ContactMerchant";
import CaptureDisputeEnterDateMerchantContact from "components/captures/DisputeTransactions/018_EnterDateMerchantContact";
import CaptureDisputeDateEnteredMerchantContact from "components/captures/DisputeTransactions/019_DateEnteredMerchantContact";
import CaptureDisputeMerchantResponseEntered from "components/captures/DisputeTransactions/020_MerchantResponseEntered";
import CaptureDisputeNoAdditionalInfoSelected from "components/captures/DisputeTransactions/021_NoAdditionalInfoSelected";
import CaptureDisputeConfirm from "components/captures/DisputeTransactions/022_Confirm";
import CaptureDisputeSubmitted from "components/captures/DisputeTransactions/023_DisputeSubmitted";
import CaptureDisputeTransactionListUpdated from "components/captures/DisputeTransactions/024_TransactionListUpdated";
import CaptureDisputeTransactionDetailsUpdated from "components/captures/DisputeTransactions/025_TransactionDetailsUpdated";
import CaptureDisputeDetails from "components/captures/DisputeTransactions/026_DisputeDetails";
import CaptureManageCardSetPIN from "components/captures/ManageCard/012_ManageCard_SetPIN";
import Test1 from "components/captures/Test/Test1";
import CallTurnOffCardConfirmView from "components/pages/ReportLostStolenPage/components/CallTurnOffCardConfirmView";
import TurnOffCardView from "components/pages/ReportLostStolenPage/components/TurnOffCardView";
import LoginWorkflow from "components/workflows/LoginWorkflow";

function App() {

    return (
      <BCMS env={ import.meta.env } customCSS="custom_css_chw23">

        {/* Home wrapper */}
        <Route path="/" element={<MainPage/>}/>
        <Route path="/home" element={<Home/>}>
      
          {/* Recent Transactions (landing) */}
          <Route path="/home/recenttransactions/" index element={<RecentTransactionsPage/>} />
          <Route path="/home/recenttransactions/:cardID" element={<RecentTransactionsPage/>} />
           
          {/* Controls and Alerts */}
          <Route path="/home/controlsalerts" element={<ControlsAlertsPage/>} >
            <Route path="/home/controlsalerts/controls" element={<ControlsView/>} />
            <Route path="/home/controlsalerts/controls/:cardID" element={ <ControlsView /> } />

            <Route path="/home/controlsalerts/alerts" element={<AlertsView/>} />
            <Route path="/home/controlsalerts/alerts/:cardID" element={ <AlertsView /> } />
          </Route> 

          {/* Verification Page */}
          <Route path="/home/verification" element={<VerificationPage/>} >
            <Route path="/home/verification/entercredentials" element={<VerificationEnterCredsView />} />
            <Route path="/home/verification/securitycode" element={<VerificationSecurityCodeView />} />
            <Route path="/home/verification/success" element={<VerificationSuccessView />} />
          </Route>

          <Route path="/home/test/:cardID" element={<Test1/>} />
          <Route path="/home/test/cardonfile/:cardID" element={<Test1/>} />
          <Route path="/home/test/recurringpayments/:cardID" element={<Test1/>} />
          <Route path="/home/test/recurringpayments/:cardID" element={<Test1/>} />
          <Route path="/home/test/securitytokenpage/:cardID" element={<Test1/>} />

           <Route path="/home/locationalerts" element={<LocationAlertsPage/>} />
           <Route path="/home/locationalerts/:cardID" element={<LocationAlertsPage/>} />
           <Route path="/home/merchantalerts" element={<MerchantAlertsPage/>} />
           <Route path="/home/merchantalerts/:cardID" element={<MerchantAlertsPage/>} />
           <Route path="/home/transactionalerts" element={<TransactionAlertsPage/>} />
           <Route path="/home/transactionalerts/:cardID" element={ <TransactionAlertsPage /> } />

           <Route path="/home/spendalerts" element={<SpendAlertsPage/>} />
           <Route path="/home/spendalerts/:cardID" element={<SpendAlertsPage/>} />
           <Route path="/home/spendcontrols" element={<SpendControlsPage/>} />
           <Route path="/home/spendcontrols/:cardID" element={ <SpendControlsPage /> } />

           <Route path="/home/locationcontrols" element={<LocationControlsPage/>} />
           <Route path="/home/locationcontrols/:cardID" element={ <LocationControlsPage /> } />
           
           <Route path="/home/transactioncontrols" element={<TransactionControlsPage/>} />
           <Route path="/home/transactioncontrols/:cardID" element={ <TransactionControlsPage /> } />

           <Route path="/home/merchantcontrols" element={<MerchantControlsPage/>} />
           <Route path="/home/merchantcontrols/:cardID" element={ <MerchantControlsPage /> } />

          {/* View All Transactions */}
           <Route path="/home/viewalltransactions" element={<ViewAllTransactionsPage/>}>
            <Route path="/home/viewalltransactions/purchases" element={<PurchasesView/>} />
            <Route path="/home/viewalltransactions/purchases/:cardID" element={ <PurchasesView /> } />
            <Route path="/home/viewalltransactions/purchases/:cardID/:workflowID" element={ <PurchasesView /> } />
            <Route path="/home/viewalltransactions/:cardID/:workflowID" element={ <PurchasesView /> } />

            <Route path="/home/viewalltransactions/feesandpayments" element={<FeesPaymentsView/>} />
            <Route path="/home/viewalltransactions/feesandpayments/:cardID" element={ <FeesPaymentsView /> } />
           </Route>

           <Route path="/home/transactiondetails" element={<TransactionDetailsPage/>} />
           <Route path="/home/transactiondetails/:transactionID" element={ <TransactionDetailsPage /> } />
           <Route path="/home/transactiondetails/:cardID/:transactionID" element={ <TransactionDetailsPage /> } />
           

           <Route path="/home/statements" element={<StatementsPage/>} />
           <Route path="/home/statements/:cardID" element={ <StatementsPage /> } />

           {/* Spend Insights */}
           <Route path="/home/spendinsights" element={<SpendInsightsPage/>}>
            <Route path="/home/spendinsights/what" element={<WhatView/>} />
            <Route path="/home/spendinsights/what/:cardID" element={ <WhatView /> } />

            <Route path="/home/spendinsights/when" element={<WhenView/>} />
            <Route path="/home/spendinsights/when/:cardID" element={ <WhenView /> } />

            <Route path="/home/spendinsights/where" element={<WhereView/>} />
            <Route path="/home/spendinsights/where/:cardID" element={ <WhereView /> } />
           </Route>

          {/* Card on File */}
           <Route path="/home/cardonfile" element={<CardOnFilePage/>}>
            <Route path="/home/cardonfile/recurringpayments" element={<RecurringPaymentsView/>} />
            <Route path="/home/cardonfile/recurringpayments/:cardID" element={ <RecurringPaymentsView /> } />

            <Route path="/home/cardonfile/cardonfile" element={<CardOnFileView/>} />
            <Route path="/home/cardonfile/cardonfile/:cardID" element={ <CardOnFileView /> } />
           </Route>

           {/*Test*/}
           <Route path="/home/cardonfileworkflow/cardonfile/:cardID" element={<CardOnFileWorkflow/>} />
           <Route path="/home/cardonfileworkflow/recurringpayments/:cardID" element={<CardOnFileWorkflow/>} />


           <Route path="/home/updatecardonfile" element={<UpdateCardOnFilePage/>} />

           <Route path="/home/merchantdetails" element={<MerchantDetailsPage/>} />
           <Route path="/home/managetravelplans" element={<ManageTravelPlansPage/>} />
           <Route path="/home/managetravelplans/:cardID" element={ <ManageTravelPlansPage /> } />
           <Route path="/home/merchantdetails/:cardID/:merchantID/:locationID" element={ <MerchantDetailsPage /> } />

           {/* Security Token */}
           <Route path="/home/securitytoken" element={<SecurityTokenPage/>}>
            <Route path="/home/securitytoken/receivetoken" element={<ReceiveTokenView/>} />
            <Route path="/home/securitytoken/receivetoken/:cardID" element={ <ReceiveTokenView /> } />
            <Route path="/home/securitytoken/receivetoken/:cardID/:routeID" element={ <ReceiveTokenView /> } />

            <Route path="/home/securitytoken/entersecuritytoken" element={<EnterSecurityTokenView/>} />
            <Route path="/home/securitytoken/entersecuritytoken/:cardID" element={ <EnterSecurityTokenView /> } />
            <Route path="/home/securitytoken/entersecuritytoken/:cardID/:routeID" element={ <EnterSecurityTokenView /> } />
            <Route path="/home/securitytoken/entersecuritytoken/:cardID/:selectionID/:routeID" element={ <EnterSecurityTokenView /> } />
           </Route>

          {/* Balance Transfer */}
           <Route path="/home/balancetransfers" element={<BalanceTransferWorkflow/>}/>
           <Route path="/home/balancetransfers/:cardID" element={<BalanceTransferWorkflow/>}/>

           <Route path="/home/addtravelplan" element={<AddTravelPlanWorkflow/>} />
           <Route path="/home/addtravelplan/:cardID" element={ <AddTravelPlanWorkflow /> } />

           <Route path="/home/edittravelplans" element={<EditTravelPlansPage/>} />
           <Route path="/home/edittravelplans/:cardID/:planID" element={<EditTravelPlansPage/>} />
           <Route path="/home/travelplan" element={<TravelPlanPage/>} />
           <Route path="/home/travelplan/:cardID/:planID" element={ <TravelPlanPage /> } />

          {/* Report Lost or Stolen */}
           <Route path="/home/reportloststolen" element={<ReportLostStolenPage/>}>
            <Route path="/home/reportloststolen/report" element={<ReportView/>} />
            <Route path="/home/reportloststolen/report/:cardID" element={<ReportView/>} /> 
            <Route path="/home/reportloststolen/reportconfirmation" element={<ReportConfirmationView/>} />
            <Route path="/home/reportloststolen/reportconfirmation/:cardID" element={<ReportConfirmationView/>} />

            <Route path="/home/reportloststolen/digitalissuanceconfirm" element={<DigitalIssuanceConfirmView />} />
            <Route path="/home/reportloststolen/digitalissuanceconfirm/:cardID" element={ <DigitalIssuanceConfirmView /> } />
            <Route path="/home/reportloststolen/digitalissuanceconfirm/:cardID/:reasonForReportingCardLostOrStolen" element={ <DigitalIssuanceConfirmView /> } />
            <Route path="/home/reportloststolen/digitalissuanceconfirm/:cardID/:reasonForReportingCardLostOrStolen/:selectedRecognizeTransactionsType" element={ <DigitalIssuanceConfirmView /> } />

            <Route path="/home/reportloststolen/sentcardtoaddress" element={ <SentCardToAddressView /> } />
            <Route path="/home/reportloststolen/sentcardtoaddress/:cardID" element={ <SentCardToAddressView /> } />
            <Route path="/home/reportloststolen/cardonitsway" element={ <CardOnItsWayView /> } />
            <Route path="/home/reportloststolen/cardonitsway/:cardID" element={ <CardOnItsWayView /> } />
            <Route path="/home/reportloststolen/recognizetransactions" element={ <RecognizeTransactionsView /> } />
            <Route path="/home/reportloststolen/recognizetransactions/:cardID" element={ <RecognizeTransactionsView /> } />

            <Route path="/home/reportloststolen/turnoffcard" element={ <TurnOffCardView /> } />
            <Route path="/home/reportloststolen/turnoffcard/:cardID" element={ <TurnOffCardView /> } />
            <Route path="/home/reportloststolen/callturnoffcardconfirm" element={ <CallTurnOffCardConfirmView />} />
            <Route path="/home/reportloststolen/callturnoffcardconfirm/:cardID" element={ <CallTurnOffCardConfirmView />} />
           </Route>

           <Route path="/home/managepin/:cardID" element={<ManagePinPage/>} />
           <Route path="/home/managepin" element={<ManagePinPage/>} />      
           <Route path="/home/region" element={<RegionPage />} />
           <Route path="/home/region/:cardID" element={<RegionPage />} />
           {/* Set Pin */}
           <Route path="/home/setpin" element={<SetPinPage/>}>
             <Route path="/home/setpin/personpin" element={<PersonPinView/>} />
             <Route path="/home/setpin/personpin/:cardID" element={ <PersonPinView /> } />

             <Route path="/home/setpin/enterpin" element={<EnterPinView/>} />
             <Route path="/home/setpin/enterpin/:cardID" element={ <EnterPinView /> } />

             <Route path="/home/setpin/setpinconfirmation" element={<SetPinConfirmationView/>} />
             <Route path="/home/setpin/setpinconfirmation/:cardID" element={ <SetPinConfirmationView /> } />
           </Route>

        
           <Route path="/home/viewdigitalcard" element={<ViewDigitalCardPage/>} />
           <Route path="/home/viewdigitalcard/:cardID" element={ <ViewDigitalCardPage /> } />

           <Route path="/home/addtowallet" element={<AddToWalletPage/>} />
           <Route path="/home/addtowallet/:cardID" element={<AddToWalletPage/>} />
           {/*<Route path="/home/balancetransfers" element={<BalanceTransfersPage/>} />*/}
           <Route path="/home/balancetransfers/:cardID" element={<BalanceTransfersPage/>} />
           
           <Route path="/home/transactiondownload" element={<TransactionDownloadPage/>} />
           <Route path="/home/transactiondownload/:cardID" element={<TransactionDownloadPage/>} />

          {/* Dispute Transaction */}
           <Route path="/home/disputetransaction" element={<DisputeTransactionWorkflow/>} />
           <Route path="/home/disputetransaction/:cardID/:transactionID" element={<DisputeTransactionWorkflow/>} />
           <Route path="/home/reviewingDispute" element={<ReviewingDisputePage/>} />
           <Route path="/home/reviewingDispute/:cardID/:transactionID" element={<ReviewingDisputePage/>} />
           
         
            {/* Messages */}
           <Route path="/home/messages" element={<MessagesPage />} />     
           <Route path="/home/messages/:cardID" element={<MessagesPage />} />   
              
            {/* One Time Payment  */}
      
              <Route path="/home/onetimepayment/onetimeform" element={<OneTimePaymentWorkFlow />}/>
              <Route path="/home/onetimepayment/onetimereview" element={<OneTimePaymentWorkFlow />}/>
              <Route path="/home/onetimepayment/onetimescheduled" element={<OneTimePaymentWorkFlow />}/>
              <Route path="/home/onetimepayment/onetimeform/:cardID" element={<OneTimePaymentWorkFlow />}/>
              <Route path="/home/onetimepayment/onetimereview/:cardID" element={<OneTimePaymentWorkFlow />}/>
              <Route path="/home/onetimepayment/onetimescheduled/:cardID" element={<OneTimePaymentWorkFlow />}/>
           

          {/* Manage Payment accounts  */}
          <Route path="/home/managepaymentaccounts" element={<ManagePaymentAccountsPage />}>
            <Route path="/home/managepaymentaccounts/managepayments" element={<ManagePaymentsView />} />
            <Route path="/home/managepaymentaccounts/managepayments/:cardID" element={<ManagePaymentsView />} />
            <Route path="/home/managepaymentaccounts/paymentaccountdetails" element={<PaymentAccountDetailsView />} />
            <Route path="/home/managepaymentaccounts/paymentaccountdetails/:cardID/:accountID" element={<PaymentAccountDetailsView />} />
          </Route>;

          {/* Autopay  */}         
            <Route path="/home/autopay/enterautopay" element={<AutoPayWorkFlow />} />
            <Route path="/home/autopay/activatedautopay" element={<AutoPayWorkFlow />} />
            <Route path="/home/autopay/enterautopay/:cardID" element={<AutoPayWorkFlow />} />
            <Route path="/home/autopay/activatedautopay/:cardID" element={<AutoPayWorkFlow />} />
         

          { /* Add Account */}
          <Route path="/home/addaccount" element={<AddAccountPage />} />
          <Route path="/home/addaccount/:cardID" element={<AddAccountPage />} />
          <Route path="/home/payments" element={<PaymentsPage />} />
          <Route path="/home/payments/:cardID" element={<PaymentsPage />} />

          <Route path="/home/enableadditionalalerts" element={<EnableAdditionalAlertsPage />} />
          <Route path="/home/enableadditionalalerts/:cardID" element={ <EnableAdditionalAlertsPage /> } />

          {/* Activate Card */}
          <Route path="/home/activatecard" element={<ActivateCardPage />} />
          <Route path="/home/activatecard/:cardID" element={<ActivateCardPage />} />
          <Route path="/home/activatecardverification" element={<ActivateCardVerificationPage />} />
          <Route path="/home/activatecardverification/:cardID" element={<ActivateCardVerificationPage />} />

          {/* Replace My Card Page */}
          <Route path="/home/replacemycard" element={<ReplaceMyCardPage />}>
            <Route path="/home/replacemycard/replacecardaddress" element={<ReplaceCardAddressView />} />
            <Route path="/home/replacemycard/replacecardaddress/:cardID" element={ <ReplaceCardAddressView /> } />

            <Route path="/home/replacemycard/replacecardconfirm" element={<ReplaceCardConfirmView />} />
            <Route path="/home/replacemycard/replacecardconfirm/:cardID" element={ <ReplaceCardConfirmView /> } />
          </Route>
          
          {/* START: Captures */}
          {/* Dispute transaction captures */}
          <Route path="/home/captureTransactionList/:cardID" element={ <CaptureTransactionList /> } />
          <Route path="/home/captureTransactionDetails/:cardID" element={ <CaptureTransactionDetails /> } />
          <Route path="/home/captureDisputeTransaction/:cardID" element={ <CaptureDisputeTransaction/> } />
          <Route path="/home/captureDisputeReason/:cardID" element={ <CaptureDisputeReason/> } />
          <Route path="/home/captureDisputeGoodsServices/:cardID" element={ <CaptureDisputeGoodsServices/> } />
          <Route path="/home/captureDisputeGoodsSelected/:cardID" element={ <CaptureDisputeGoodsSelected/> } />
          <Route path="/home/captureDisputeProductEntered/:cardID" element={ <CaptureDisputeProductEntered/> } />
          <Route path="/home/captureDisputeEnterDisputeExplanation/:cardID" element={ <CaptureDisputeEnterDisputeExplanation/> } />
          <Route path="/home/captureDisputeExplanationEntered/:cardID" element={ <CaptureDisputeExplanationEntered/> } />
          <Route path="/home/captureDisputeDeliveryEntered/:cardID" element={ <CaptureDisputeDeliveryEntered/> } />
          <Route path="/home/captureDisputeReturnEntered/:cardID" element={ <CaptureDisputeReturnEntered/> } />
          <Route path="/home/captureDisputeReturnMethodDD/:cardID" element={ <CaptureDisputeReturnMethodDD/> } />
          <Route path="/home/captureDisputeReturnMethodSelected/:cardID" element={ <CaptureDisputeReturnMethodSelected/> } />
          <Route path="/home/captureDisputeReturnDateEntered/:cardID" element={ <CaptureDisputeReturnDateEntered/> } />
          <Route path="/home/captureDisputeDisputeAmount/:cardID" element={ <CaptureDisputeDisputeAmount/> } />
          <Route path="/home/captureDisputeDisputeAmountDD/:cardID" element={ <CaptureDisputeDisputeAmountDD/> } />
          <Route path="/home/captureDisputeAmountSelected/:cardID" element={ <CaptureDisputeAmountSelected/> } />
          <Route path="/home/captureDisputeContactMerchant/:cardID" element={ <CaptureDisputeContactMerchant/> } />
          <Route path="/home/captureDisputeEnterDateMerchantContact/:cardID" element={ <CaptureDisputeEnterDateMerchantContact/> } />
          <Route path="/home/captureDisputeDateEnteredMerchantContact/:cardID" element={ <CaptureDisputeDateEnteredMerchantContact/> } />
          <Route path="/home/captureDisputeMerchantResponseEntered/:cardID" element={ <CaptureDisputeMerchantResponseEntered/> } />
          <Route path="/home/captureDisputeNoAdditionalInfoSelected/:cardID" element={ <CaptureDisputeNoAdditionalInfoSelected/> } />
          <Route path="/home/captureDisputeConfirm/:cardID" element={ <CaptureDisputeConfirm/> } />
          <Route path="/home/captureDisputeSubmitted/:cardID" element={ <CaptureDisputeSubmitted/> } />
          <Route path="/home/captureDisputeTransactionListUpdated/:cardID" element={ <CaptureDisputeTransactionListUpdated/> } />
          <Route path="/home/captureDisputeTransactionDetailsUpdated/:cardID" element={ <CaptureDisputeTransactionDetailsUpdated/> } />
          <Route path="/home/captureDisputeDetails/:cardID" element={ <CaptureDisputeDetails/> } />

          <Route element={ <SecurityTokenPage /> }>
            <Route path="/home/captureManageCardSetPIN" element={ <CaptureManageCardSetPIN /> } />
          </Route>
          {/* END: Captures */}

         {/* Home wrapper */}
        </Route>

        {/* Login Page */}
        <Route path="/loginPage" element={<LoginPage/>} />
        <Route path="/login" element={<LoginWorkflow/>} />
        <Route path="/settings" element={<SettingsPage/>} />
        <Route path="/settings/hideshowcards" element={<HideShowCardsPage/>} />
        <Route path="/settings/personalinformation" element={<PersonalInformationPage />} /> 

        {/* CardFree Cash */}
        <Route path="/cardfreecash/accesscode" element={<CardFreeCashWorkflow />} />
        <Route path="/cardfreecash/selectcashamount" element={<CardFreeCashWorkflow />} />
        <Route path="/cardfreecash/accesscode/:cardID" element={<CardFreeCashWorkflow />} />
        <Route path="/cardfreecash/selectcashamount/:cardID" element={<CardFreeCashWorkflow />} />

        {/* Add Card */}
        <Route path="/addcard" element={<AddCardPage/>} />
        <Route path="/addcard/:cardID" element={<AddCardPage/>} />
        <Route path="/addcard/cardverification" element={<AddCardVerificationPage/>} />
        <Route path="/addcard/cardverification/:cardID" element={<AddCardVerificationPage/>} />
        <Route path="/addcard/userregistration" element={<UserRegistrationPage/>} />
        <Route path="/addcard/userregistration/:cardID" element={<UserRegistrationPage/>} />
        <Route path="/addcard/userverification" element={<UserVerificationPage/>} />
        <Route path="/addcard/userverification/:cardID" element={<UserRegistrationPage/>} />
        <Route path="/addcard/privacypolicy" element={<PrivacyPolicyPage/>} />
        <Route path="/addcard/privacypolicy/:cardID" element={<PrivacyPolicyPage/>} />
        <Route path="/addcard/termsconditions" element={<TermsConditionsPage/>} />
        <Route path="/addcard/termsconditions/:cardID" element={<TermsConditionsPage/>} />

        <Route path="/addCardWorkflow" element={ <AddCardWorkflow /> } />
        
        <Route path="/capture/*" element={<IntegrationContainer/>}>

        </Route> 



      </BCMS>
  );
}

export default App;
